import type { CrudFilters } from '@refinedev/core';
import { SummaryAlertsBar } from '@/components/common/SummaryAlertsBar';
import { alertQueries, statQueries } from './viewQueries';
import type { MasterFileView, MasterFileViewKey } from './viewQueries';

interface MasterAssetFileAlertsProps {
  activeKey: MasterFileViewKey | null;
  /** Page-level scope applied on top of every query's own filters. */
  scope?: CrudFilters;
  /** Click toggles the query's filter set; `null` clears it. */
  onSelect: (query: MasterFileView | null) => void;
}

/** "Wymaga uwagi" bar for master files. */
export const MasterAssetFileAlerts = ({
  activeKey,
  scope = [],
  onSelect,
}: MasterAssetFileAlertsProps) => (
  <SummaryAlertsBar<MasterFileViewKey>
    resource="content_catalog.master_asset_files"
    labelPrefix="content_catalog.master_asset_files"
    alerts={alertQueries()}
    stats={statQueries()}
    activeKey={activeKey}
    scope={scope}
    onSelect={onSelect}
  />
);
